import React, { FunctionComponent } from "react"
import ratmService from "../../../utils/RATMService"
import ratmHash from "../../../utils/RATMHash"
import "./TemplateManagementTableContextMenu.css"

interface Props {
    index: number
    RoleTemplateId: number
}

const TemplateManagementTableContextMenu: FunctionComponent<Props> = (props) => {

    const { index, RoleTemplateId } = props
    const { buildRoleLinkHashTable } = ratmHash
    const { manageState } = ratmService

    return (
        <div id={`6a3bac12eb364c1fa84e0fb2237c3ad7-${index}`} className="TemplateManagementTableContextMenu">
            <div className="TemplateManagementTableContextMenuItem">
                <span
                    className="material-icons eef2114434e6db7118a170e63fbe3"
                    onClick={() => {
                        const links = ratmHash.lookupHashTableItem(RoleTemplateId, 1)[1].templateItem.RoleTemplatePortalRoleLnk
                        buildRoleLinkHashTable(links)
                        manageState([{ key: "addOrEditTemplateId", value: RoleTemplateId }])
                    }}
                >edit</span>
            </div>
            <div className="TemplateManagementTableContextMenuItem">
                <span
                    className="material-icons bdce833943b43dcb81446049d9c06eb"
                    onClick={() => manageState([{ key: "deleteTemplateId", value: RoleTemplateId }])}
                >delete</span>
            </div>
        </div>
    )
}

export default TemplateManagementTableContextMenu